import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from 'react';
import * as rsuite from "rsuite";
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import Drp_Project from '../Project/Drp_Projects';

import axios from 'axios';
import { trackPromise } from "react-promise-tracker";
import { useNavigate } from 'react-router-dom';

const CompanyProp = forwardRef((props, ref) => {

    //#region const 

    let navigate = useNavigate();
    const [Id, setId] = useState(General.GuidEmpty());
    const [Title, setTitle] = useState("");
    const [ProjectId, setProjectId] = useState(General.GuidEmpty());
    const [IsActive, setIsActive] = useState(false);
    const [ShowLoader, setShowLoader] = useState(false);
    const ProjectRef = useRef();

    //#endregion

    //#region Methods 

    useImperativeHandle(ref, () => ({
        ShowEdit(Id) {
            if (Id != undefined)
                setId(Id);
        }
    }))

    const setSelectedProjectId = (e) => {
        setProjectId(e);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (Title === "") {
            General.ShowMsg(Enum.MsgType.error, "عنوان مشتری را مشخص نمایید");
            return;
        }

        setShowLoader(true);
        var RequestOption = {
            method: 'Post',
            url: General.ApiRoute() + '/Company/Save',
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
            },
            data: {
                "Id": Id,
                "Title": Title,
                "ProjectId": ProjectId,
                "IsActive": IsActive
            },
            withCredentials: true
        }
        trackPromise(
            axios(RequestOption)
                .then(function (res) {
                    if (res.data.isSuccess) {

                        General.ShowMsg(Enum.MsgType.success, General.SaveSuccess());
                        setShowLoader(false);
                        props.onSubmit();
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, res.data.error);
                        setShowLoader(false);
                    }

                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 401) {
                            General.ShowMsg(Enum.MsgType.error, General.unAuthorize());


                        }
                        else if (error.response.status === 403) {
                            General.ShowMsg(Enum.MsgType.error, General.AccessDenied());

                        }
                    }
                    else {
                        General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                        setShowLoader(false);
                    }
                })
        )
    };

    const Bind = () => {
        setShowLoader(true);
        var RequestOption = {
            mthod: 'Get',
            url: General.ApiRoute() + "/Company/GetById",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                Id: Id
            }
            , withCredentials: true


        }

        axios(RequestOption)
            .then(function (res) {
                setTitle(res.data.title);
                setProjectId(res.data.projectId);
                setIsActive(res.data.isActive);
                setShowLoader(false);
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        General.ShowMsg(Enum.MsgType.error, General.unAuthorize());


                    }
                    else if (error.response.status === 403) {
                        General.ShowMsg(Enum.MsgType.error, General.AccessDenied());

                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                    setShowLoader(false);
                }
            })
    }

    useEffect(()=>{

        ProjectRef.current.Get();
    },[])

    useEffect(() => {
        if (Id != General.GuidEmpty())
            Bind();
    }, [Id])
    //#endregion


    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>عنوان</label>
                <rsuite.Input
                    type="text"
                    value={Title}
                    onChange={value => setTitle(value)}
                    required />
            </div>
            <div>
                <label>پـــروژه</label>
                <Drp_Project ref={ProjectRef} className="w-100" onSelect={setSelectedProjectId} />
            </div>
            <div>

                <rsuite.Checkbox checked={IsActive} onChange={()=>setIsActive(!IsActive)}/> فعال می باشد
            </div>
            <rsuite.Divider />
            <div align="left">
                {
                    !ShowLoader ?

                        <rsuite.Button appearance="primary" className="mt-2" onClick={handleSubmit}>
                            ثبت مشتری
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" className="mt-2" disabled>
                            <rsuite.Loader content="در حال ارسال اطلاعات..." />
                        </rsuite.Button>
                }
            </div>

        </form>
    );
});

export default CompanyProp;